/* eslint-disable */
import {
  getReportByUniqueCode,
  postAnswers,
  postNewVictim,
  postVictimAnswers
} from 'api/ApiMethods';
import { findAnswer, findItemByUuid, addVictimIdToAnswers } from 'utils/util';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const postReport = createAsyncThunk(
  'answers/post',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const reporting_party = state?.reporter?.reporting_party;
      const worksite = state?.reporter?.worksite;
      const victims = state?.answers?.victims;
      const subjects = state?.answers?.subjects;
      const dataToSend = {
        report: {
          name: 'TEMPORARY_CASE_NAME',
          organization: localStorage.getItem('orgId'),
          report_status: 1,
          // City, state and country are looked up from the zip on the server
          workplace: {
            work_zip_code: worksite?.work_zip_code || '',
            specific_worksite: worksite?.specific_worksite || ''
          },
          is_urgent: false
        },
        answers: state?.answers?.answers,
        reporters: [
          {
            reporting_party
          }
        ],
        victims: [],
        subjects: subjects?.map((subject) => {
          const { id, ...restOfSubject } = subject;

          return {
            subject: restOfSubject
          };
        })
      };
      const { data } = await postAnswers(dataToSend);
      const { data: reportData } = await getReportByUniqueCode(
        data?.unique_code
      );
      const reportId = reportData[0]?.id;

      const victimPromises = victims.map(async (victim) => {
        const { image, victimId, ...reducedVictim } = victim;
        const newVictim = {
          victim: {
            ...reducedVictim,
            report: reportId
          }
        };

        return await postNewVictim(newVictim).then((res) => {
          return { victim: res.data, victimId };
        });
      });

      Promise.all(victimPromises)
        .then((res) => {
          const victimAnswersPromises = state?.answers?.victimAnswers.map(
            async (answers) => {
              const newVictim = res.find((data) => {
                return data?.victimId == answers?.victimId;
              });
              const updatedAnswers = addVictimIdToAnswers(
                answers?.answers,
                newVictim?.victim?.victim?.id
              );
              return await postVictimAnswers(
                reportId,
                updatedAnswers,
                'REPORTER'
              );
            }
          );

          Promise.all(victimAnswersPromises);
        })
        .catch((error) => {
          console.log('victims error: ', error);
        });

      return data;
    } catch (error) {
      console.log('ERROR : ', error);
      if (error instanceof Error) {
        return rejectWithValue('Reset Password failed');
      }
    }
  }
);

const initialState = {
  answers: [],
  report_unique_code: undefined,
  newCaseUrgent: false,
  victims: [],
  victimAnswers: [],
  subjects: []
};

const answersSlice = createSlice({
  name: 'answers',
  initialState: {
    answers: [],
    report_unique_code: undefined,
    newCaseUrgent: false,
    victims: [],
    victimAnswers: [],
    subjects: []
  },
  reducers: {
    setInitialAnswers: (state, action) => {
      state.answers = action.payload;
    },
    updateAnswerText: (state, action) => {
      const { uuid, text } = action.payload;
      const item = findItemByUuid(state.answers, uuid);
      if (item) {
        item.answer.text = text;
      }
    },
    addOptions: (state, action) => {
      const { uuid, options } = action.payload;
      const item = findItemByUuid(state.answers, uuid);
      if (item) {
        item.options = options;
      }
    },
    setNewCaseUrgent: (state, action) => {
      state.newCaseUrgent = action.payload?.value;
    },
    updateVictimAnswerOption: (state, { payload }) => {
      const victim = state?.victimAnswers?.find(
        (victim) => victim.victimId === payload?.victimId
      );

      if (victim) {
        const item = findAnswer(victim?.answers, payload?.answerUUID);
        if (item) {
          item.options = payload?.answerText;
        }
      }
    },
    updateVictimAnswerText: (state, { payload }) => {
      const victim = state?.victimAnswers?.find(
        (victim) => victim.victimId === payload?.victimId
      );

      if (victim) {
        const item = findAnswer(victim?.answers, payload?.answerUUID);
        if (item) {
          item.answer.text = payload?.answerText;
        }
      }
    },
    addNewVictimForm: (state, { payload }) => {
      state.victims.push({
        victimId: payload?.victimId,
        full_name: '',
        phone: '',
        email: '',
        work_site: '',
        city: '',
        state: '',
        work_country: '',
        relationship_to_sender: '',
        number_of_communications: '',
        work_location: '',
        person_type: 'OTHER',
        description: '',
        answers: payload?.answers
      });
      state.victimAnswers.push({
        victimId: payload?.victimId,
        answers: payload?.defaultAnswers
      });
    },
    setVictimValues: (state, action) => {
      const { field, value, victimId } = action.payload;
      state.victims = state?.victims.map((victim) => {
        if (victim?.victimId === victimId) {
          return { ...victim, [field]: value };
        }
        return victim;
      });
    },
    deleteVictim: (state, action) => {
      const { victimId } = action.payload;

      // special case if we want to delete first victim and that victim is only victim in array
      if (!victimId && state.victims.length === 1) {
        state.victims = [];
        return;
      }
      const victimIndex = state.victims.findIndex(
        (victim) => victim.victimId === victimId
      );
      // case if we want to delete first victim but it is not only victim in array
      if (!victimId) {
        state.victims = [
          ...state.victims.slice(0, 0),
          ...state.victims.slice(1)
        ];
        return;
      }
      // all other cases
      state.victims = [
        ...state.victims.slice(0, victimIndex + 1),
        ...state.victims.slice(victimIndex + 2)
      ];
    },

    setSubjectValues: (state, action) => {
      const { field, value, subjectId } = action.payload;
      state.subjects = state?.subjects.map((subject) => {
        if (subject?.subjectId === subjectId) {
          return { ...subject, [field]: value };
        }
        return subject;
      });
    },
    addNewSubjectForm: (state, { payload }) => {
      state.subjects.push({
        subjectId: payload?.subjectId,
        full_name: '',
        phone: '',
        email: '',
        work_site: '',
        city: '',
        state: '',
        work_country: '',
        person_type: 'OTHER',
        description: ''
      });
    },
    deleteSubject: (state, action) => {
      const { subjectId } = action.payload;

      // special case if we want to delete first victim and that victim is only victim in array
      if (!subjectId && state.subjects.length === 1) {
        state.subjects = [];
        return;
      }
      const subjectIndex = state.subjects.findIndex(
        (subject) => subject.subjectId === subjectId
      );
      // case if we want to delete first victim but it is not only victim in array
      if (!subjectId) {
        state.subjects = [
          ...state.subjects.slice(0, 0),
          ...state.subjects.slice(1)
        ];
        return;
      }
      // all other cases
      state.subjects = [
        ...state.subjects.slice(0, subjectIndex + 1),
        ...state.subjects.slice(subjectIndex + 2)
      ];
    },
    ansreset: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(postReport.fulfilled, (state, { payload }) => {
      state.report_unique_code = payload?.unique_code;
    });
  }
});

export const {
  setInitialAnswers,
  updateAnswerText,
  addOptions,
  setNewCaseUrgent,
  addNewVictimForm,
  setVictimValues,
  updateVictimAnswerOption,
  updateVictimAnswerText,
  addNewSubjectForm,
  setSubjectValues,
  deleteVictim,
  deleteSubject,
  ansreset
} = answersSlice.actions;
export default answersSlice.reducer;
